<template>
  <el-dialog
    :title="title"
    :visible.sync="isShow"
    @close="handleClose"
    width="50%"
  >
    <el-form ref="Form" :model="item" :rules="rules">
      <el-row>
        <el-col
          >被删除的评论将被移至回收站，请在下方填写删除原因：</el-col
        ></el-row
      >
      <el-row>
        <el-col>
          <el-form-item prop="delReason">
            <el-input
              v-model="item.delReason"
              size="small"
              placeholder="请输入删除原因"
              style="width: 100%"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="提交"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import { commentDelete } from "@/api/comment";

export default {
  name: "deleteCurd",

  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      uuid: "",
      item: {
        delReason: ""
      },
      rules: {
        delReason: [
          { required: true, message: "删除原因不能为空", trigger: "blur" },
          { required: true, message: "删除原因不能为空", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    closeFrom() {
      this.isShow = false;
      // 点击取消 数据重置
    },
    handleClose() {
      this.$refs["Form"].resetFields();
      this.item = {};
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    submitForm() {
      this.$refs["Form"].validate(valid => {
        if (valid) {
          commentDelete({
            uuids: [this.uuid],
            isValid: 0,
            delReason: this.item.delReason
          }).then(res => {
            if (!res || res.code != 0) return;
            this.$message.success(res.msg);
            Bus.$emit("reload");
          });
          this.closeFrom();
        }
      });
    }
  },
  created() {
    Bus.$on("deleteComment", id => {
      this.uuid = id;
      this.showFrom("系统提示");
    });
  }
};
</script>
